import { arrayActions } from "@/commonJS/Actions/actionInterface";
import getData from "@/commonJS/getData";

const performArrayOperations = (array:any[], actions:arrayActions[], data:any, payload:any) => {
  for (let i = 0; i < actions.length; i++) {
    const arrayAction = actions[i];
    
    
    switch (arrayAction.type) {
      case 'push':
        array.push(data);
        break;
      case "filter":
        array = array?.filter((arrData:any)=>{
          // @ts-ignore
          const data1 = actions[i].filter !== undefined ?  getData(actions[i].filter ,arrData) : undefined;
          const dynamicValueData = actions[i].filter?.dynamicValue !== undefined ? getData(actions[i].filter?.dynamicValue ,payload) : undefined;
          if(data1 === actions[i].filter?.value || data1 === dynamicValueData){
            return arrData
          }
        }) ;                
        break;
        case "findIndex":
          return array?.findIndex(getData(actions[i]?.find ?? {key: ""}, actions[i]?.find?.source === "DEFAULT" ? (payload??"") : ""))
        case "unshift":
          const generateExtractedValues = (keyStructure: any, obj:any) => {
            let object: any = {};
            
            Object.entries(keyStructure).forEach(([key, valueObj]: any) => {
              object[key] = getData(
                valueObj,
                valueObj.source === "DEFAULT"
                ? obj 
                : payload
              );
            });
            
            return object;
          };
          const newObject =  generateExtractedValues(actions[i]?.create??{}, data)
          array?.unshift(actions[i]?.create ? newObject : data)
          return array;
        case "remove":
          const index = array?.findIndex((item: any) => {
            return (
              // @ts-ignore
              getData(actions[i]?.compareSource, item) ===
              // @ts-ignore
              getData(actions[i]?.compareSource, payload)
            );
          });
          array.splice(index, 1);
        case "removeItem":
          array.splice(array.indexOf(data),1);
          return array;
      case "create-array":
        return Array.from(array, (obj:any) => (actions[i]?.arrayItemsType === "number" ? getData(actions[i].create ?? {key: ""},obj,): {}))
        break;
      case 'splice':
        array.splice(Number(arrayAction.firstArgs ?? 0));
        break;
      case "concat": 
       return array.concat(data)
      case "fill": 
       return Array(Number(arrayAction?.length?.toString() ?? "0")).fill(arrayAction?.value);
      default:
        break;
    }
  }  
  
  return array;
}

export default performArrayOperations;